import React from 'react';
import '@fontsource/source-sans-pro';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
import { CssBaseline, ThemeProvider, createTheme, AppBar, Toolbar, Typography, Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DonationForm from './components/donation/DonationForm';
import DonationSuccess from './components/donation/DonationSuccess';
import DonationError from './components/donation/DonationError';
import AdminLoginPage from './components/admin/AdminLoginPage';
import AdminDashboardPage from './components/admin/AdminDashboardPage';
import './App.css';
const backgroundImage = '/assets/background.jpg';

// Create a theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#003366', // A deep, academic blue
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#3498db', // blue
      contrastText: '#000000',
    },
    background: {
      default: '#f5f5f5', // A light, neutral gray
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.4) !important',
          backdropFilter: 'blur(12px)',
          color: '#003366 !important',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1) !important',
          border: '1px solid rgba(0, 0, 0, 0.1) !important',
          '&.MuiAppBar-colorInherit': {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            color: '#003366',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App" style={{ '--bg-image': `url(${process.env.PUBLIC_URL}${backgroundImage})` } as React.CSSProperties}>
            <Box sx={{ width: '100%', maxWidth: '1200px', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingX: { xs: 0, sm: 2 } }}>
              <AppBar 
                position="static"
                color="inherit"
                sx={{ 
                  width: '100%', 
                  maxWidth: '1200px', 
                  borderRadius: '8px 8px 0 0',
                  borderBottom: 'none !important',
                  '&.MuiAppBar-root': {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    padding: { xs: '12px 16px', sm: '0 24px' }
                  }
                }}
              >
                <Toolbar 
                  sx={{ 
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'center', sm: 'flex-start' },
                    padding: '0 !important',
                    minHeight: 'auto !important',
                    gap: { xs: 1, sm: 2 }
                  }}
                >
                  <a href="https://odtugv.org.tr" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', justifyContent: 'center' }}>
                    <img 
                      src="/vakif_logo.png" 
                      alt="Vakfı Logo" 
                      style={{ 
                        height: '40px',
                        width: 'auto',
                        maxWidth: '100%',
                        objectFit: 'contain'
                      }} 
                    />
                  </a>
                  <Typography 
                    variant="h4" 
                    component="div" 
                    sx={{ 
                      color: '#003366', 
                      fontWeight: 700, 
                      textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.125rem' },
                      lineHeight: { xs: 1.5, sm: 1 },
                      margin: 0,
                      padding: { xs: '4px 0', sm: '8px 0' }
                    }}
                  >
                    ODTÜ Geliştirme Vakfı Bağış Platformu
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box 
                component="main"
                sx={{
                  width: '100%',
                  maxWidth: '1200px',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '0 0 8px 8px',
                  padding: { xs: 0 },
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  borderTop: 'none'
                }}
              >
                <Routes>
                  <Route path="/admin/login" element={<AdminLoginPage />} />
                  <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                  <Route path="/" element={<DonationForm />} />
                  <Route path="/donation/success" element={<DonationSuccess />} />
                  <Route path="/donation/error" element={<DonationError />} />
                </Routes>
              </Box>
            </Box>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
